import { Flex, VStack } from '@chakra-ui/react';

import PageLayout from '@/ui/Layout/PageLayout';

type Args<T, R> = {
  entireInput: T[];
  fn: (input: T[]) => Promise<R>;
  batchSize?: number;
  batchName: string;
};

export async function runBatchedFunction<T, R>({
  entireInput,
  fn,
  batchSize: batchSizeOverride,
  batchName,
}: Args<T, R>): Promise<R[]> {
  const batchSize = batchSizeOverride || 25;
  const inputSize = entireInput.length;
  const allResults: R[] = [];
  console.log(
    `[Batch] ${batchName} Starts with with input length: ${inputSize} and batch size ${batchSize}`
  );
  for (let i = 0; i < inputSize; i += batchSize) {
    const batch = entireInput.slice(i, i + batchSize);
    console.log(
      `[Batch] ${batchName} running next batch with length: ${
        batch.length
      } now. (${i < inputSize ? i : inputSize}/${inputSize})`
    );
    const batchResut = await fn(batch);
    allResults.push(batchResut);
  }
  return allResults;
}

function AdminTestPage() {
  return (
    <PageLayout>
      <Flex alignItems="center" justifyContent="center" gap="20px">
        <VStack maxWidth="300px"></VStack>
      </Flex>
    </PageLayout>
  );
}

export default AdminTestPage;
